<template>
  <div class="top-banner-container" :class="{ 'spe': spe }">
    <img class="banner-img" :src="bannerPicSrc" alt="" @click="handleLink">
    <div class="banner-text">
      <slot class="banner-title" name="banner-title"></slot>
      <slot name="banner-content"></slot>
      <count-down v-if="countDown && data.etime" :etime="data.etime" class="count-down-container"></count-down>
    </div>
  </div>
</template>

<script>
import CountDown from "./CountDown";
import { isApp } from "../utils/utils"
export default {
  name: "TopBanner",
  props: {
    data: {
      type: Object,
      default: () => { },
    },
    defaultPic: {
      type: Boolean,
      default: true,
    },
    countDown: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      spe: false
    };
  },
  computed: {
    bannerPicSrc() {
      // console.log("banner", this.defaultPic, this.data);
      if (
        (this.defaultPic && this.data.tmpl_id == "0") ||
        (this.defaultPic && this.data.tmpl_id == "1") ||
        (this.defaultPic && this.data.tmpl_id == "3")
      ) {
        return "https://img11.iqilu.com/29/vote/1.png";
      } else if (
        (this.defaultPic && this.data.tmpl_id == "2") ||
        (this.defaultPic && this.data.tmpl_id == "4")
      ) {
        return "https://img11.iqilu.com/29/vote/2.png";
      } else {
        return this.data.cover_pic;
      }
    },
  },
  watch: {},
  components: {
    CountDown,
  },
  methods: {
    handleLink() {
      const link = this.data.cover_pic_link
      if (!link) return
      if (isApp()) {
        this.$webBridgeApi.router({
          route: 'url',
          params: {
            url: link
          }
        })
      } else {
        window.location.href = link
      }
    }
  },
  created() {
    // console.log(this.countDown);
    // console.log(this.data);
  },
  mounted() {
    let id = this.$utils.getUrlParams("id");
    if (id == 'MzE5OjIyN2My') {
      this.spe = true
    }
  }
};
</script>

<style scoped lang="less">
.top-banner-container {
  width: 100%;
  color: #fff;
  position: relative;

  .banner-text {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;

    .banner-title {
      font-size: 0.62rem;
      text-shadow: 3px 3px 8px var(--themeColor);
      padding: 0.65rem 0 0 0.6rem;
    }

    .banner-content {
      font-size: 0.34rem;
      padding: 0.1rem 0 0 0.6rem;
      text-shadow: 3px 3px 8px var(--themeColor);
    }

    .count-down-container {
      position: absolute;
      bottom: -0.25rem;
    }
  }

  img {
    max-width: 100%;
    display: block;
    margin: 0 auto;
  }
}



.top-banner-container.spe {
  height: 9.67rem !important;
}
</style>